<script>
  import AppPageHeader from '../../../components/main/PageHeader'
  import EmptyList from '../../../components/list/EmptyList'

  import * as restfulService from '../../../services/restfulService'
  import * as $contratoService from '../services/contratoService'

  import bus from '@utils/bus'
  import {mapGetters} from 'vuex'

  import {isEmpty} from 'lodash'

  export default {
    components: {AppPageHeader, EmptyList},
    mounted () {
      this.carregarContratos()
    },
    data () {
      return {
        contrato: null,
        contratos: [],
        periodos: []
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      periodosVazio: function () {
        return isEmpty(this.periodos)
      },
      posGraduacao () {
        if (this.contrato) {
          if (this.periodos.length) {
            return this.periodos[0].matriculas[0].ref_tipo_formacao === 3 ||
              this.periodos[0].matriculas[0].ref_tipo_formacao === 4
          }
        }
        return false
      },
      periodosComplementares () {
        if (this.contrato) {
          if (this.periodos.length) {
            let total = {}

            this.periodos.forEach(periodo => {
              periodo.matriculas.forEach(matricula => {
                if (parseInt(matricula.ref_tipo_atividade) === 6) {
                  if (typeof total[matricula.disciplina] === 'undefined') {
                    total[matricula.disciplina] = { total: 0 }
                  }
                  total[matricula.disciplina].total += parseFloat(matricula.carga_horaria_aprov) || 0
                  total[matricula.disciplina].disciplina = matricula.disciplina
                }
              })
            })
            return total
          }
        }
        return false
      }
    },
    methods: {
      carregarContratos () {
        $contratoService.buscarContratos()
          .then((response) => {
            this.contratos = [...this.contratos, ...response]
            if (this.contratos.length === 1) {
              this.contrato = this.contratos[0].id
              this.selecionaContrato(this.contrato)
            } else {
              bus.$emit('hide-loader')
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      selecionaContrato (value) {
        this.periodos.splice(0)
        if (value) {
          bus.$emit('show-loader')
          restfulService.get('contrato', 'matriculas', this.contrato)
            .then((response) => {
              this.periodos = [...this.periodos, ...response]
              bus.$emit('hide-loader')
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
        }
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box">
            <v-container fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-select :items="contratos"
                                  v-model="contrato"
                                  label="Curso"
                                  no-data-text="Nenhum curso encontrado"
                                  clearable
                                  @input="selecionaContrato"
                                  item-value="id"
                                  item-text="descricao"/>
                    </v-flex>
                </v-layout>
            </v-container>
            <empty-list v-if="periodosVazio"
                        title="Selecione o Curso"
                        description="As suas disciplinas serão mostradas conforme o contrato selecionado"/>
            <div v-if="!periodosVazio">
                <h3 class="page-content-title">Disciplinas</h3>
                <div class="responsive-table">
                    <table class="v-table table-disciplinas-cursadas">
                        <tbody v-for="periodo in periodos">
                        <tr class="header-table">
                            <td colspan="5">Período: <strong>{{periodo.descricao}}</strong></td>
                        </tr>
                        <tr class="subheader-table">
                            <td>Disciplina</td>
                            <td>Situação</td>
                            <td>Turno</td>
                            <td>Frequência</td>
                            <td v-if="posGraduacao">Conceito</td>
                            <td v-if="!posGraduacao">Média Final</td>
                        </tr>
                        <tr v-for="matricula in periodo.matriculas" v-if="matricula.ref_tipo_atividade !== 6">
                            <td>{{matricula.disciplina}}</td>
                            <td>{{matricula.estado}}</td>
                            <td>{{matricula.turno}}</td>
                            <td>{{matricula.frequencias[0].frequencia}} %</td>
                            <td v-if="posGraduacao">{{matricula.conceito1}}</td>
                            <td v-if="!posGraduacao && matricula.media_final > 0">{{matricula.media_final}}</td>
                            <td v-if="!posGraduacao && matricula.media_final == 0 && matricula.estado == 'Aprovado'"> - </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="periodosComplementares">
                <h3 class="page-content-title">Atividades Complementares</h3>
                <div class="responsive-table">
                    <table class="v-table table-disciplinas-cursadas">
                        <tbody>
                        <tr class="subheader-table">
                            <td>Disciplina</td>
                            <td v-if="!posGraduacao">Carga Horária Cadastrada</td>
                        </tr>
                        <tr v-for="periodo in periodosComplementares">
                            <td>{{periodo.disciplina}}</td>
                            <td v-if="!posGraduacao">{{periodo.total}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                </div>

            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .table-disciplinas-cursadas {
        tbody {
            tr {
                &.header-table {
                    td {
                        background-color: #ebebeb;
                        height: 34px;
                        text-align: center;
                    }
                }
                &.subheader-table {
                    td {
                        font-weight: bold;
                        height: 38px;
                    }
                }
                &:last-child {
                    td {
                        padding-top: 14px;
                        padding-bottom: 45px;
                        height: auto;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// DisciplinasCursadas.vue?d7a15dd6